import { Injectable } from '@angular/core';
import { PaymentRequestApiType } from '@app/shared/enums/PaymentRequestApiType';
import { environment } from '@environments/environment';
import _ from 'lodash';
import { BehaviorSubject } from 'rxjs';
import { DetectBrowser, MobileDevices } from './detect-browser.services';

@Injectable({
  providedIn: 'root'
})
export class GenericPaymentRequestService extends DetectBrowser{

  paymentRequest: PaymentRequest = null;
  canMakePayment = new BehaviorSubject(PaymentRequestApiType.Other);
  private details: PaymentDetailsInit = {
    total: {
      amount: {
        currency: 'USD',
        value: '1',
      },
      label: 'Pay'
    }
  };
  constructor() {
    super();
  }
  public initializeService() {
    if(this.paymentRequest) {
      this.setCanMakePayment();
    } else {
      this.paymentRequest = new PaymentRequest(_.cloneDeep(environment.CHASE_PAYMENT_CONFIG), this.details);
      this.setCanMakePayment();
    }
  }
  private setCanMakePayment() {
    this.paymentRequest.canMakePayment().then(result => {
      if (result) {
        if (result && this.isSafari()) {
          console.log('Chase Apple Pay');
          this.canMakePayment.next(PaymentRequestApiType.ApplePay);
        } else if (result && this.isChrome() && this.getDeviceLoggedIn() === MobileDevices.Andriod) {
          console.log('Chase Google Pay');
          this.canMakePayment.next(PaymentRequestApiType.GooglePay);
        }
      }
    });
  }

  public updatePaymentRequest( details: PaymentDetailsInit,
    methods: PaymentMethodData[]) {
        this.paymentRequest = new PaymentRequest(methods, details);
  }

  public getPaymentApiType(): PaymentRequestApiType {
    if (this.isSafari()) {
      return PaymentRequestApiType.ApplePay;
    } else if(this.isChrome() && this.getDeviceLoggedIn() === MobileDevices.Andriod) {
      return PaymentRequestApiType.GooglePay;
    }
    return PaymentRequestApiType.Other;
  }
}
